"use strict";
var core_1 = require("@angular/core");
var color_picker_service_1 = require("./color-picker.service");
var color_picker_component_1 = require("./color-picker.component");
var ColorPickerDirective = (function () {
    function ColorPickerDirective(vcRef, el, service, cfr) {
        this.vcRef = vcRef;
        this.el = el;
        this.service = service;
        this.cfr = cfr;
        this.colorPickerChange = new core_1.EventEmitter(true);
        this.colorPickerSelect = new core_1.EventEmitter(true);
        this.cpToggleChange = new core_1.EventEmitter(true);
        this.cpPosition = 'right';
        this.cpPositionOffset = '0%';
        this.cpPositionRelativeToArrow = false;
        this.cpOutputFormat = 'hex';
        this.cpPresetLabel = 'Preset colors';
        this.cpCancelButton = false;
        this.cpCancelButtonClass = 'cp-cancel-button-class';
        this.cpCancelButtonText = 'Cancel';
        this.cpOKButton = false;
        this.cpOKButtonClass = 'cp-ok-button-class';
        this.cpOKButtonText = 'OK';
        this.cpFallbackColor = '#fff';
        this.cpHeight = 'auto';
        this.cpWidth = '230px';
        this.cpIgnoredElements = [];
        this.cpDialogDisplay = 'popup';
        this.cpSaveClickOutside = true;
        this.cpAlphaChannel = 'hex6';
        this.ignoreChanges = false;
        this.created = false;
    }
    ColorPickerDirective.prototype.ngOnChanges = function (changes) {
        if (changes.cpToggle) {
            if (changes.cpToggle.currentValue)
                this.openDialog();
            if (!changes.cpToggle.currentValue && this.dialog)
                this.dialog.closeColorPicker();
        }
        if (changes.colorPicker) {
            if (this.dialog && !this.ignoreChanges) {
                if (this.cpDialogDisplay === 'inline') {
                    this.dialog.setInitialColor(changes.colorPicker.currentValue);
                }
                this.dialog.setColorFromString(changes.colorPicker.currentValue, false);
            }
            this.ignoreChanges = false;
        }
        if (changes.cpPresetLabel || changes.cpPresetColors) {
            if (this.dialog) {
                this.dialog.setPresetConfig(this.cpPresetLabel, this.cpPresetColors);
            }
        }
    };
    ColorPickerDirective.prototype.ngOnInit = function () {
        var hsva = this.service.stringToHsva(this.colorPicker);
        if (hsva === null)
            hsva = this.service.stringToHsva(this.colorPicker, true);
        if (hsva == null) {
            hsva = this.service.stringToHsva(this.cpFallbackColor);
        }
        this.colorPickerChange.emit(this.service.outputFormat(hsva, this.cpOutputFormat, this.cpAlphaChannel === 'hex8'));
    };
    ColorPickerDirective.prototype.onClick = function () {
        var _this = this;
        if (this.cpIgnoredElements.filter(function (item) { return item === _this.el.nativeElement; }).length === 0) {
            this.openDialog();
        }
    };
    ColorPickerDirective.prototype.openDialog = function () {
        if (!this.created) {
            this.created = true;
            var compFactory = this.cfr.resolveComponentFactory(color_picker_component_1.ColorPickerComponent);
            var injector = core_1.ReflectiveInjector.fromResolvedProviders([], this.vcRef.parentInjector);
            var cmpRef = this.vcRef.createComponent(compFactory, 0, injector, []);
            cmpRef.instance.setDialog(this, this.el, this.colorPicker, this.cpPosition, this.cpPositionOffset, this.cpPositionRelativeToArrow, this.cpOutputFormat, this.cpPresetLabel, this.cpPresetColors, this.cpCancelButton, this.cpCancelButtonClass, this.cpCancelButtonText, this.cpOKButton, this.cpOKButtonClass, this.cpOKButtonText, this.cpHeight, this.cpWidth, this.cpIgnoredElements, this.cpDialogDisplay, this.cpSaveClickOutside, this.cpAlphaChannel);
            this.dialog = cmpRef.instance;
        }
        else if (this.dialog) {
            this.dialog.openDialog(this.colorPicker);
        }
    };
    ColorPickerDirective.prototype.colorChanged = function (value, ignore) {
        if (ignore === void 0) { ignore = true; }
        this.ignoreChanges = ignore;
        this.colorPickerChange.emit(value);
    };
    ColorPickerDirective.prototype.colorSelected = function (value) {
        this.colorPickerSelect.emit(value);
    };
    ColorPickerDirective.prototype.changeInput = function (value) {
        this.dialog.setColorFromString(value, true);
    };
    ColorPickerDirective.prototype.toggle = function (value) {
        this.cpToggleChange.emit(value);
    };
    return ColorPickerDirective;
}());
ColorPickerDirective.decorators = [
    { type: core_1.Directive, args: [{
                selector: '[colorPicker]',
                host: {
                    '(input)': 'changeInput($event.target.value)',
                    '(click)': 'onClick()'
                }
            },] },
];
/** @nocollapse */
ColorPickerDirective.ctorParameters = function () { return [
    { type: core_1.ViewContainerRef, },
    { type: core_1.ElementRef, },
    { type: color_picker_service_1.ColorPickerService, },
    { type: core_1.ComponentFactoryResolver, },
]; };
ColorPickerDirective.propDecorators = {
    'colorPicker': [{ type: core_1.Input, args: ['colorPicker',] },],
    'colorPickerChange': [{ type: core_1.Output, args: ['colorPickerChange',] },],
    'colorPickerSelect': [{ type: core_1.Output, args: ['colorPickerSelect',] },],
    'cpToggle': [{ type: core_1.Input, args: ['cpToggle',] },],
    'cpToggleChange': [{ type: core_1.Output, args: ['cpToggleChange',] },],
    'cpPosition': [{ type: core_1.Input, args: ['cpPosition',] },],
    'cpPositionOffset': [{ type: core_1.Input, args: ['cpPositionOffset',] },],
    'cpPositionRelativeToArrow': [{ type: core_1.Input, args: ['cpPositionRelativeToArrow',] },],
    'cpOutputFormat': [{ type: core_1.Input, args: ['cpOutputFormat',] },],
    'cpPresetLabel': [{ type: core_1.Input, args: ['cpPresetLabel',] },],
    'cpPresetColors': [{ type: core_1.Input, args: ['cpPresetColors',] },],
    'cpCancelButton': [{ type: core_1.Input, args: ['cpCancelButton',] },],
    'cpCancelButtonClass': [{ type: core_1.Input, args: ['cpCancelButtonClass',] },],
    'cpCancelButtonText': [{ type: core_1.Input, args: ['cpCancelButtonText',] },],
    'cpOKButton': [{ type: core_1.Input, args: ['cpOKButton',] },],
    'cpOKButtonClass': [{ type: core_1.Input, args: ['cpOKButtonClass',] },],
    'cpOKButtonText': [{ type: core_1.Input, args: ['cpOKButtonText',] },],
    'cpFallbackColor': [{ type: core_1.Input, args: ['cpFallbackColor',] },],
    'cpHeight': [{ type: core_1.Input, args: ['cpHeight',] },],
    'cpWidth': [{ type: core_1.Input, args: ['cpWidth',] },],
    'cpIgnoredElements': [{ type: core_1.Input, args: ['cpIgnoredElements',] },],
    'cpDialogDisplay': [{ type: core_1.Input, args: ['cpDialogDisplay',] },],
    'cpSaveClickOutside': [{ type: core_1.Input, args: ['cpSaveClickOutside',] },],
    'cpAlphaChannel': [{ type: core_1.Input, args: ['cpAlphaChannel',] },],
};
exports.ColorPickerDirective = ColorPickerDirective;
//# sourceMappingURL=color-picker.directive.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-color-picker/dist/lib/color-picker.directive.js
// module id = ./node_modules/ngx-color-picker/dist/lib/color-picker.directive.js
// module chunks = 3